(() => {
  const mq = window.matchMedia('(max-width: 720px)');
  let cleanup = null;

  const init = () => {
    if (!mq.matches || cleanup) return;
    const form = document.querySelector('[data-collection-filters]');
    const controls = form?.querySelector('.aa-filter-controls');
    const categoryDetails = controls?.querySelector('.aa-category-filter');
    const categoryPanel = categoryDetails?.querySelector('.aa-category-groups');
    if (!form || !controls || !categoryPanel) return;

    // Never carry an open desktop filter state into the mobile DOM rebuild.
    controls.querySelectorAll('[data-filter-dropdown]').forEach(dropdown => {
      dropdown.open = false;
      dropdown.classList.remove('is-expanded');
      dropdown.querySelector(':scope > summary')?.setAttribute('aria-expanded','false');
    });

    form.classList.add('mobile-drawers-ready');

    const toolbar = document.createElement('div');
    toolbar.className = 'aa-mobile-collection-toolbar';
    toolbar.innerHTML = `
      <button type="button" data-aa-mobile-categories><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 6h14M5 12h14M5 18h14"/></svg><span>All Categories</span></button>
      <button type="button" data-aa-mobile-filters><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h2M10 17h10M14 4v6M8 14v6"/></svg><span>Filter &amp; Sort</span></button>`;
    form.insertBefore(toolbar, controls);

    const shade = document.createElement('button');
    shade.type = 'button';
    shade.className = 'aa-collection-drawer-shade';
    shade.setAttribute('aria-label', 'Close');
    form.appendChild(shade);

    const makeDrawer = (side, title) => {
      const drawer = document.createElement('aside');
      drawer.className = `aa-collection-drawer ${side}`;
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-label', title);
      drawer.innerHTML = `<div class="aa-collection-drawer-inner"><div class="aa-collection-drawer-head"><strong>${title}</strong><button class="aa-collection-drawer-close" type="button" aria-label="Close"></button></div><div class="aa-collection-drawer-body"></div></div>`;
      form.appendChild(drawer);
      return drawer;
    };

    const categoryDrawer = makeDrawer('left', 'All Categories');
    const categoryBody = categoryDrawer.querySelector('.aa-collection-drawer-body');
    categoryBody.appendChild(categoryPanel);

    const filterDrawer = makeDrawer('right', 'Filter & Sort');
    const filterBody = filterDrawer.querySelector('.aa-collection-drawer-body');
    filterBody.innerHTML = `<div class="aa-mobile-filter-tabs"><button type="button" class="active" data-aa-filter-tab="filters">FILTERS</button><button type="button" data-aa-filter-tab="sorting">SORTING</button></div><div class="aa-mobile-filter-pane active" data-aa-filter-pane="filters"></div><div class="aa-mobile-filter-pane" data-aa-filter-pane="sorting"></div><div class="aa-mobile-filter-actions"><button class="aa-mobile-filter-apply" type="button">SEE ALL</button></div>`;
    const filtersPane = filterBody.querySelector('[data-aa-filter-pane="filters"]');
    const sortingPane = filterBody.querySelector('[data-aa-filter-pane="sorting"]');
    const moved = [];
    Array.from(controls.children).forEach(node => {
      if (!node.matches?.('.aa-filter') || node.classList.contains('aa-category-filter')) return;
      const marker = document.createComment('aa-mobile-filter-marker');
      node.parentNode.insertBefore(marker, node);
      moved.push({ node, marker });
      if (node.classList.contains('aa-sort-filter')) sortingPane.appendChild(node); else filtersPane.appendChild(node);
    });

    filterBody.querySelectorAll('[data-aa-filter-tab]').forEach(tab => tab.addEventListener('click', () => {
      const key = tab.dataset.aaFilterTab;
      filterBody.querySelectorAll('[data-aa-filter-tab]').forEach(item => item.classList.toggle('active', item === tab));
      filterBody.querySelectorAll('[data-aa-filter-pane]').forEach(pane => pane.classList.toggle('active', pane.dataset.aaFilterPane === key));
    }));

    const count = (form.querySelector('.aa-filter-results')?.textContent || '').match(/\d+/)?.[0];
    const apply = filterBody.querySelector('.aa-mobile-filter-apply');
    if (count) apply.textContent = `SEE ALL (${count})`;

    let closeTimer;
    let returnFocus;
    const openDrawer = drawer => {
      clearTimeout(closeTimer);
      returnFocus = document.activeElement;
      window.ArteOverlay?.acquire('collection');
      [categoryDrawer, filterDrawer].forEach(other => {
        if (other === drawer) return;
        other.classList.remove('open');
        other.setAttribute('aria-hidden', 'true');
      });
      shade.classList.add('open');
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('aa-collection-drawer-open');
      drawer.querySelector('.aa-collection-drawer-close')?.focus({ preventScroll: true });
    };
    const closeDrawers = (immediate = false) => {
      clearTimeout(closeTimer);
      shade.classList.remove('open');
      [categoryDrawer, filterDrawer].forEach(drawer => { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); });
      document.body.classList.remove('aa-collection-drawer-open');
      if (immediate || document.documentElement.classList.contains('aa-viewport-changing') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.ArteOverlay?.release('collection');
      } else {
        closeTimer = setTimeout(() => window.ArteOverlay?.release('collection'), 360);
      }
      if (!immediate) returnFocus?.focus({ preventScroll: true });
    };
    const onKeydown = event => {
      const drawer = [categoryDrawer, filterDrawer].find(item => item.classList.contains('open'));
      if (!drawer) return;
      if (event.key === 'Escape') closeDrawers();
      if (event.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll('button,a[href],input:not([disabled]),summary')).filter(node => node.getClientRects().length && !node.closest('[hidden]'));
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    };
    document.addEventListener('keydown', onKeydown);

    toolbar.querySelector('[data-aa-mobile-categories]').addEventListener('click', () => openDrawer(categoryDrawer));
    toolbar.querySelector('[data-aa-mobile-filters]').addEventListener('click', () => openDrawer(filterDrawer));
    shade.addEventListener('click', closeDrawers);
    form.querySelectorAll('.aa-collection-drawer-close').forEach(button => button.addEventListener('click', closeDrawers));
    apply.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());

    cleanup = () => {
      closeDrawers(true);
      clearTimeout(closeTimer);
      document.removeEventListener('keydown', onKeydown);
      categoryDetails.appendChild(categoryPanel);
      moved.forEach(({node, marker}) => {
        node.open = false;
        node.classList.remove('is-expanded');
        node.querySelector(':scope > summary')?.setAttribute('aria-expanded','false');
        marker.parentNode?.insertBefore(node, marker);
        marker.remove();
      });
      toolbar.remove(); shade.remove(); categoryDrawer.remove(); filterDrawer.remove();
      form.classList.remove('mobile-drawers-ready');
      cleanup = null;
    };
  };

  const stableHandoff = action => {
    const root = document.documentElement;
    const anchor = document.querySelector('.aa-collection-hero') || document.querySelector('.aa-collection-product-grid');
    const beforeTop = anchor?.getBoundingClientRect().top;
    const beforeScrollY = window.scrollY;

    root.classList.add('aa-collection-breakpoint-changing');
    action();

    requestAnimationFrame(() => {
      const afterTop = anchor?.getBoundingClientRect().top;
      if (Number.isFinite(beforeTop) && Number.isFinite(afterTop)) {
        const delta = afterTop - beforeTop;
        if (Math.abs(delta) > .5) window.scrollTo({ left: window.scrollX, top: beforeScrollY + delta, behavior:'auto' });
      }
      requestAnimationFrame(() => root.classList.remove('aa-collection-breakpoint-changing'));
    });
  };

  let lastMobileState = mq.matches;
  const sync = () => {
    const nextMobileState = mq.matches;
    if (nextMobileState === lastMobileState && (nextMobileState ? cleanup : !cleanup)) return;
    stableHandoff(() => {
      if (nextMobileState) init();
      else cleanup?.();
    });
    lastMobileState = nextMobileState;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true}); else sync();
  const onBreakpointChange = () => sync();
  if (mq.addEventListener) mq.addEventListener('change', onBreakpointChange); else mq.addListener(onBreakpointChange);
})();
